<script setup>
// Fase 2.5 do plano .ai/instagram-integration-correcao-evolucao-plan.md.
// Sinaliza ANTES de virar requires_reconnect (banner "Atenção", cor amber) —
// distinto do InboxReconnectionRequired (ruby), que só aparece depois que o
// token já quebrou.
import { ref } from 'vue';
import Banner from 'dashboard/components-next/banner/Banner.vue';

import instagramClient from 'dashboard/api/channel/instagramClient';

import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';

const { t } = useI18n();

const isRequestingAuthorization = ref(false);

async function requestAuthorization() {
  try {
    isRequestingAuthorization.value = true;
    const {
      data: { url },
    } = await instagramClient.createAuthorization();

    window.location.href = url;
  } catch (error) {
    useAlert(t('INBOX_MGMT.ADD.INSTAGRAM.ERROR_AUTH'));
  } finally {
    isRequestingAuthorization.value = false;
  }
}
</script>

<template>
  <Banner
    color="amber"
    class="mx-8 mt-5"
    :action-label="t('INBOX_MGMT.ADD.INSTAGRAM.TOKEN_EXPIRING_SOON_ACTION')"
    @action="requestAuthorization"
  >
    {{ t('INBOX_MGMT.ADD.INSTAGRAM.TOKEN_EXPIRING_SOON') }}
  </Banner>
</template>
